export const sectionLabel =
  "font-plex-sans text-[16px] leading-[20.8px] font-semibold text-[#161616]";

export const fieldLabel =
  "font-plex-sans text-[16px] leading-[24px] font-medium text-[#161616]";

export const bodyText =
  "font-plex-sans text-[16px] leading-[24px] text-[#5e5e5e]";

const focusRing =
  "focus-visible:outline-2 focus-visible:outline-offset-[2px] focus-visible:outline-[#161616]";

export const inputStyle = `font-plex-sans h-[36px] w-full max-w-[320px] rounded-[8px] border border-[rgba(22,22,22,0.30)] bg-[#fffdf4] px-[12px] text-[16px] leading-[24px] text-[#161616] disabled:cursor-not-allowed disabled:text-[#5e5e5e] ${focusRing}`;

export const circleStyle =
  "flex size-[64px] shrink-0 items-center justify-center overflow-hidden rounded-full border border-[rgba(22,22,22,0.30)] bg-[#fffdf4] font-plex-sans text-[20px] leading-none text-[#161616]";

export const checkboxStyle = `size-[16px] shrink-0 cursor-pointer appearance-none rounded-[3px] border border-[rgba(22,22,22,0.30)] bg-[#fffdf4] bg-center bg-no-repeat checked:border-transparent checked:bg-[url('/account/checkbox-checked.svg')] disabled:cursor-not-allowed ${focusRing}`;

export const linkStyle = `text-[#161616] underline decoration-[rgba(22,22,22,0.35)] underline-offset-[4px] motion-safe:transition-colors hover:decoration-[#161616] ${focusRing}`;
